<app-page headline="Buyer Login Upload">
  <div stack-layout gap="md">
    <app-card headline="Upload Buyer Login File">
      <oui-file-drop-zone
        #fileDropZone
        [height]="200"
        [allowedFileExtensions]="['xlsx', 'xls']"
        style="width: 100%"
        [helpTemplate]="fileDropZoneContent"
        (fileAttached)="handleFileAttached($event)"
        (fileRemoved)="selectedFile.set(undefined)"
      />
      <ng-template #fileDropZoneContent>
        <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
          <Text role="title-small" align="center">
            Drag and drop the file here or
            <a
              href="javascript:void(0)"
              (click)="fileDropZone.openFileSelector()"
              >Choose File</a
            >
          </Text>
          <Text role="title-small" align="center" color="on-background-variant">
            Please ensure the uploaded file contains all required buyer login fields.
          </Text>
        </div>
      </ng-template>
      <div row-layout justifyContent="center" [fullWidth]="true" gap="md">
        <button
          text-button
          size="md"
          variant="secondary"
          (click)="fileDropZone.openFileSelector()"
        >
          Browse Files
        </button>
        <button
          text-button
          variant="success"
          size="md"
          (click)="uploadFile()"
          [disabled]="!selectedFile()"
        >
          Upload
        </button>
      </div>
    </app-card>
  </div>

  <div box-layout paddingVertical="md" [grow]="1">
    @if (buyerService.noBuyerLoginImportHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-small">No buyer login upload history.</Text>
      </div>
    } @else {
      <app-log-table
        [datasource]="dataSyncHistoryDatasource()"
        label="Upload History"
        [loading]="buyerService.buyerLoginImportHistory.isLoading()"
        (reload)="buyerService.buyerLoginImportHistory.reload()"
        [heightOffset]="500"
      />
    }
  </div>
</app-page>

<app-validation-errors-dialog
  dialogTitle="Buyer Login Upload"
  [errors]="validationErrors()"
/>
